import {buildHandleEnterKeyPress} from '../utils/accessibility';

const onClickHandler = (day, onClick) => (event) => {
  if (event && event.preventDefault) {
    event.preventDefault();
  }

  onClick(day);
};

export default function Day({day, disabled, onClick}) {
  const handleClick = onClickHandler(day, onClick);
  return (
    <button
      className="day-button"
      disabled={disabled}
      onClick={handleClick}
      onKeyDown={buildHandleEnterKeyPress(handleClick)}
      tabIndex={0}>
      <div>
        <span>
          <p className="font-bold text-black">&nbsp;&nbsp;{day.format('D')}&nbsp;&nbsp;</p>
        </span>
      </div>
    </button>
  );
}
